import {
  DependencyList,
  EffectCallback,
  useEffect,
  useLayoutEffect,
  useRef,
} from "react";

export function useDidUpdateEffect(fn: EffectCallback, inputs: DependencyList) {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
    } else {
      return fn();
    }
  }, inputs);
}

export function useDidUpdateLayoutEffect(
  fn: EffectCallback,
  inputs: DependencyList
) {
  const didMountRef = useRef(false);

  useLayoutEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
    } else {
      return fn();
    }
  }, inputs);
}
